/* cut-to-size.js — behaviour for sections/cut-to-size.liquid (Session P1).
   No Liquid. Everything shop-specific arrives via #cts-data.

   26 Sep 2026: UI REBUILT on the riven page's markup (hp__ dropdown steps,
   breakdown, arrival box, installer block, sticky bar). The LOGIC below is
   unchanged from the 25 Sep build that passed 19 scenarios: slab choice,
   packer, pricing, basket pairing. Keep the two layers apart — a change of
   look should never touch the logic block.

   THE FLOW
     1–3. Finish, thickness, grade (riven only)
     4.   Up to three pieces, length × width in mm. The page picks the
          CHEAPEST IN-STOCK slab of that stone that all the pieces nest into
          and draws the cutting layout. That slab is what the customer pays for.
     5.   Turnaround: Standard (SVC-CUT-STD) or Priority (SVC-CUT-EXP)
     6.   Delivery: Collect / Pallet / Express pallet, standard or oversized
          band decided by the slab that was picked.

   DATES (BSD-073, 14 Oct 2026): DELIVERED BY the 14th / 7th day, pallet included (arriveHtml). Was: READY after 14 (Standard) or 7 (Priority) calendar
   days; a ready date on a weekend, bank holiday or shutdown day moves to the
   next working day. Then the carrier takes 2–4 (pallet) or 1–2 (express)
   working days (an estimate).

   CUTTING RULES are copied verbatim from assets/hearth-parent.js
   (10mm kerf, 50mm minimum, guillotine cuts, saw-like layout preference).
   Boundary tests after any change:
     riven 1200 x 900: 2 x (1200 x 445) ACCEPT · 2 x (1200 x 450) next slab up
                       1 x (1200 x 40) REFUSE (under 50mm)

   PARTS MODE (26 Sep 2026, limestone): switched on only when the page
   carries #cts-parts (sections/cut-to-size-parts.liquid). The customer
   chooses Front hearth / Front + chamber / Chamber; each part is cut from
   its OWN slab, limited to that part's slab sizes, and the order carries one
   cutting charge. Without #cts-parts (slate) nothing below changes.

   FIXED PART (26 Sep 2026, late): a part may carry "fixed" (a stock variant
   sold whole, never cut — the black limestone Hand-Cut 1200 x 380). It has no
   size boxes and no diagram; its slab goes in the basket with the others on
   the same _pair and the one cutting charge. A choice may carry "only" (a
   finish key): it is offered only for that colour, else the page falls back
   to "both" (or the default).

   SECONDS MODE (28 Sep 2026, Workshop Seconds): switched on only when the
   page carries #cts-seconds (sections/cut-to-size-seconds.liquid). Steps 1–3
   (finish, thickness, grade) are replaced by ONE step: pick a seconds slab
   (a card per in-stock variant of the seconds product). The pieces are cut
   from that slab only, and must leave at least SEC.minOffcut % of it free so
   the workshop can cut around the damage. One service (SEC.svc), Standard
   turnaround only. Without #cts-seconds nothing below changes.

   SAVE PANEL (28 Sep 2026): the slate Cut to Size page may also carry
   #cts-offer (sections/cut-to-size-offer.liquid), the in-stock Workshop
   Seconds slabs. It is used only to price the SAME pieces on a seconds slab
   (offerQuote) and hand the result to assets/cut-to-size-offer.js through
   window.ctsOffer and the cts:offer event. It never changes this page's own
   plan, price or basket. Seconds mode also reads ?pieces=1200x400,600x300 and
   ?del=deliver|express so the panel's link arrives with the pieces and the
   delivery choice already entered. */
(function () {
  var dataEl = document.getElementById('cts-data');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var C = D.copy || {};
  var PCC = D.postcode || {};

  var CUT_KERF = 10;
  var MIN_CUT = 50;
  var MAX_PIECES = D.maxPieces || 3;

  function $(id) { return document.getElementById(id); }
  function money(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var FIN = {};
  D.finishes.forEach(function (f) { FIN[f.key] = f; });

  var PARTS = null;
  try { var pEl = document.getElementById('cts-parts'); if (pEl) PARTS = JSON.parse(pEl.textContent); } catch (e) { PARTS = null; }
  if (PARTS && !(PARTS.choices && PARTS.choices.length && PARTS.parts)) PARTS = null;

  var SEC = null;
  try { var sEl = document.getElementById('cts-seconds'); if (sEl) SEC = JSON.parse(sEl.textContent); } catch (e) { SEC = null; }
  if (SEC && !(SEC.slabs && SEC.svc && SEC.svc.id)) SEC = null;
  if (SEC) PARTS = null;
  var SC = SEC ? (SEC.copy || {}) : {};

  var OFFER = null;
  try { var oEl = document.getElementById('cts-offer'); if (oEl && !SEC && !PARTS) OFFER = JSON.parse(oEl.textContent); } catch (e) { OFFER = null; }
  if (OFFER && !(OFFER.slabs && OFFER.svc && OFFER.svc.id)) OFFER = null;
  var PREFILL = [];

  var state = {
    fin: null, thk: '20mm', grade: 'Standard',
    pieces: [{ l: '', w: '' }],
    speed: 'standard', del: 'collect',
    part: PARTS ? (PARTS.def || PARTS.choices[0].value) : null,
    sec: null
  };

  /* Initial finish: ?finish=riven|honed|brushed, else riven. Thickness and
     grade may also be carried across from a hearth page: ?thk=30mm&grade=Premium */
  (function initial() {
    var q = null;
    try { q = new URL(window.location.href).searchParams; } catch (e) { q = null; }
    var want = q ? (q.get('finish') || '').toLowerCase() : '';
    state.fin = (want && FIN[want]) ? want : (D.finishes[0] ? D.finishes[0].key : null);
    var t = q ? (q.get('thk') || '') : '';
    if (/^(20|30)mm$/.test(t)) state.thk = t;
    var g = q ? (q.get('grade') || '') : '';
    if (/^premium/i.test(g)) state.grade = 'Premium';
    var pt = q ? (q.get('part') || '').toLowerCase() : '';
    if (PARTS && pt && PARTS.choices.some(function (c) { return c.value === pt; })) state.part = pt;
    if (SEC && q && q.get('slab')) state.sec = q.get('slab');
    var dq = q ? (q.get('del') || '') : '';
    if (SEC && /^(deliver|express)$/.test(dq)) state.del = dq;
    var pcq = q ? (q.get('pieces') || '') : '';
    if (SEC && /^\d{2,4}x\d{2,4}(,\d{2,4}x\d{2,4}){0,2}$/.test(pcq)) {
      PREFILL = pcq.split(',').map(function (t) { var a = t.split('x'); return { l: a[0], w: a[1] }; });
    }
  })();

  /* Seconds mode helpers. The chosen slab sets finish, thickness and grade,
     so the gallery, the breakdown and the Cut to Size comparison follow it. */
  function secList() {
    return SEC.slabs.filter(function (v) { return inStock(v) && v.l > 0 && v.w > 0; })
      .sort(function (a, b) { return a.price - b.price; });
  }
  function secSlab() {
    var l = secList();
    for (var i = 0; i < l.length; i++) if (String(l[i].id) === String(state.sec)) return l[i];
    return l[0] || null;
  }
  function secSync() {
    var v = secSlab();
    state.sec = v ? v.id : null;
    if (v) {
      if (FIN[v.fin]) state.fin = v.fin;
      state.thk = v.thk;
      state.grade = v.grade || 'Standard';
    }
    state.speed = 'standard';
    return v;
  }
  function secUse() { return 100 - (SEC.minOffcut || 30); }
  function secRoom(sp, L, W) {
    var used = sp.reduce(function (a, p) { return a + p.l * p.w; }, 0);
    return used <= L * W * secUse() / 100;
  }
  function secMaxOne(v) {
    var L = Math.max(v.l, v.w), W = Math.min(v.l, v.w);
    return L + ' × ' + Math.floor(W * secUse() / 1000) * 10 + 'mm';
  }
  function normalPrice(v) {
    var f = FIN[v.fin]; if (!f) return 0;
    var m = f.variants.filter(function (x) {
      return normSize(x.size) === normSize(v.size) && String(x.thk) === String(v.thk) && (!v.grade || String(x.grade) === v.grade);
    })[0];
    return m ? m.price : 0;
  }

  /* Parts mode helpers. activeParts() lists the part keys for the choice
     made (e.g. ['front', 'chamber']); piece i belongs to activeParts()[i]. */
  function choiceFor(v) {
    for (var i = 0; i < PARTS.choices.length; i++) if (PARTS.choices[i].value === v) return PARTS.choices[i];
    return PARTS.choices[0];
  }
  function activeParts() { return PARTS ? choiceFor(state.part).parts : null; }
  function isFixed(key) { return !!(PARTS && PARTS.parts[key] && PARTS.parts[key].fixed); }
  function cutKeys() { return activeParts().filter(function (k) { return !isFixed(k); }); }
  function choiceOk(c) { return !c.only || c.only === state.fin; }
  function syncChoices() {
    /* Colour-only choices (hand-cut: black) come and go with the colour. */
    var list = PARTS.choices.filter(choiceOk);
    if (!list.some(function (c) { return c.value === state.part; })) {
      var fb = list.filter(function (c) { return c.value === 'both'; })[0] || list.filter(function (c) { return c.value === PARTS.def; })[0] || list[0];
      state.part = fb.value;
    }
    setOptions(pcsSel, list.map(function (c) { return { value: c.value, label: c.label }; }), state.part);
  }
  function normSize(s) { return String(s || '').replace(/\s+/g, '').replace(/[xX]/g, '×'); }
  function partCands(key, all) {
    var sizes = (PARTS.parts[key].sizes || []).map(normSize);
    return all.filter(function (v) { return sizes.indexOf(normSize(v.size)) >= 0; });
  }

  /* ===========================================================================
     LOGIC — unchanged from the 25 Sep build
     =========================================================================== */
  function isRiven() { return state.fin === 'riven'; }
  function gradeOk(v) {
    if (!isRiven()) return true;
    /* "Premium — Factory Dressed" is a pre-dressed stock slab; it is never a
       cutting blank, so it is not offered here. */
    return String(v.grade) === state.grade;
  }
  function inStock(v) { return v.available !== false && v.qty > 0; }
  function candidates() {
    if (SEC) { var sv = secSlab(); return sv ? [sv] : []; }
    var f = FIN[state.fin];
    if (!f) return [];
    return f.variants.filter(function (v) {
      return String(v.thk) === state.thk && gradeOk(v) && inStock(v) && v.l > 0 && v.w > 0;
    }).sort(function (a, b) { return a.price - b.price; });
  }
  function thicknessesFor(fin) {
    var seen = [];
    FIN[fin].variants.forEach(function (v) { if (v.thk && seen.indexOf(v.thk) < 0) seen.push(v.thk); });
    return seen.sort();
  }
  function thkAvailable(thk) {
    return FIN[state.fin].variants.some(function (v) {
      return String(v.thk) === thk && inStock(v) && (!isRiven() || String(v.grade) === 'Standard' || String(v.grade) === 'Premium');
    });
  }
  function gradeAvailable(g) {
    return FIN[state.fin].variants.some(function (v) { return String(v.thk) === state.thk && String(v.grade) === g && inStock(v); });
  }
  function cheapest(list) { return list.length ? list[0] : null; }
  function gradeDelta() {
    /* Premium uplift at 1200 x 900 for the chosen thickness — the size most
       cuts come from. Falls back to the smallest difference found. */
    var f = FIN.riven; if (!f) return null;
    var best = null;
    f.variants.forEach(function (s) {
      if (s.grade !== 'Standard' || s.thk !== state.thk) return;
      f.variants.forEach(function (p) {
        if (p.grade === 'Premium' && p.thk === s.thk && p.size === s.size) {
          var d = p.price - s.price;
          if (s.size === '1200 × 900') best = d;
          else if (best === null) best = d;
        }
      });
    });
    return best;
  }
  function thkDelta(thk) {
    /* Extra for a thickness against 20mm at the same size (and grade). */
    if (thk === '20mm') return null;
    var f = FIN[state.fin], d = null;
    f.variants.forEach(function (a) {
      if (a.thk !== '20mm' || !gradeOk(a)) return;
      f.variants.forEach(function (b) {
        if (b.thk === thk && b.size === a.size && b.grade === a.grade) {
          /* Quote the 1200 x 900 difference, the size most cuts come from —
             the same rule gradeDelta() uses. The total is always exact. */
          var x = b.price - a.price;
          if (a.size === '1200 × 900') d = x;
          else if (d === null) d = x;
        }
      });
    });
    return d;
  }

  /* ---------------------------------------------------------------------------
     Guillotine packer — VERBATIM from assets/hearth-parent.js (24 Sep 2026).
     --------------------------------------------------------------------------- */
  function packPieces(pieces, L, W) {
    var best = null, bestScore = Infinity, nodes = 0;
    function roomFor(dim, avail) {
      if (dim > avail) return false;
      if (dim === avail) return true;
      return dim + CUT_KERF <= avail;
    }
    function score(acc) {
      var bands = {}, rot = 0, ragged = 0, k;
      for (var i = 0; i < acc.length; i++) {
        if (acc[i].rot) rot++;
        k = String(acc[i].y);
        if (!bands[k]) bands[k] = [];
        if (bands[k].indexOf(acc[i].w) < 0) bands[k].push(acc[i].w);
      }
      for (k in bands) { if (bands.hasOwnProperty(k)) ragged += bands[k].length - 1; }
      return ragged * 100 + rot * 10;
    }
    function place(list, x, y, aL, aW, acc) {
      if (nodes++ > 20000) return;
      if (!list.length) {
        var s = score(acc);
        if (s < bestScore) { bestScore = s; best = acc.slice(); }
        return;
      }
      for (var i = 0; i < list.length; i++) {
        var p = list[i], rest = list.slice(0, i).concat(list.slice(i + 1));
        var ors = (p.l === p.w) ? [[p.l, p.w, false]] : [[p.l, p.w, false], [p.w, p.l, true]];
        for (var o = 0; o < ors.length; o++) {
          var pl = ors[o][0], pw = ors[o][1];
          if (!roomFor(pl, aL) || !roomFor(pw, aW)) continue;
          var acc2 = acc.concat([{ idx: p.idx, x: x, y: y, l: pl, w: pw, rot: ors[o][2] }]);
          place(rest, x + pl + CUT_KERF, y, aL - pl - CUT_KERF, aW, acc2);
          place(rest, x, y + pw + CUT_KERF, aL, aW - pw - CUT_KERF, acc2);
        }
      }
    }
    place(pieces, 0, 0, L, W, []);
    return best;
  }

  /* ---------------------------------------------------------------------------
     The cutting check. Returns the slab to use and its layout, or a message.
     --------------------------------------------------------------------------- */
  function specs() {
    return state.pieces.map(function (p, i) {
      return { i: i + 1, l: parseInt(p.l, 10) || 0, w: parseInt(p.w, 10) || 0 };
    });
  }
  function cutPlan() {
    var sp = specs();
    if (sp.some(function (s) { return !s.l || !s.w; })) return { ok: false, msg: '', slab: null };
    var thin = sp.filter(function (s) { return Math.min(s.l, s.w) < MIN_CUT; });
    if (thin.length) {
      var who = sp.length === 1 ? 'That piece is' : ('Piece ' + thin[0].i + ' is');
      return { ok: false, slab: null, msg: who + ' under ' + MIN_CUT + 'mm on its short side. We do not cut narrower than ' + MIN_CUT + 'mm.' };
    }
    var cands = candidates();
    if (!cands.length) return { ok: false, slab: null, msg: SEC ? SC.soldOut : C.noStock };
    if (PARTS) return partsPlan(sp, cands);
    var pieces = sp.map(function (s, k) { return { idx: k, l: Math.max(s.l, s.w), w: Math.min(s.l, s.w) }; });
    for (var i = 0; i < cands.length; i++) {
      var v = cands[i], L = Math.max(v.l, v.w), W = Math.min(v.l, v.w);
      if (pieces.some(function (p) { return p.l > L || p.w > W; })) continue;
      var layout = packPieces(pieces, L, W);
      if (layout && SEC && !secRoom(sp, L, W)) return { ok: false, slab: null, msg: String(SC.noRoom || '').replace('{use}', secUse()) };
      if (layout) return { ok: true, slab: v, layout: { placements: layout, L: L, W: W }, msg: '' };
    }
    if (SEC) return { ok: false, slab: null, msg: SC.noFit };
    /* Nothing fits. Say which limit was hit. */
    var biggest = cands.reduce(function (a, b) { return (b.l * b.w > a.l * a.w) ? b : a; });
    var BL = Math.max(biggest.l, biggest.w), BW = Math.min(biggest.l, biggest.w);
    /* 26 Sep (limestone pair): when no one slab is both the longest and the
       widest (limestone 1200 x 380 vs 900 x 600; slate 1500 x 900 vs
       1200 x 1200), name each size that no other slab covers, instead of
       only "the largest". */
    var dominant = cands.every(function (c) { return Math.max(c.l, c.w) <= BL && Math.min(c.l, c.w) <= BW; });
    var sizesSay = BL + ' × ' + BW + 'mm';
    if (!dominant) {
      var seenS = [];
      cands.slice().sort(function (a, b) { return Math.max(b.l, b.w) - Math.max(a.l, a.w); }).forEach(function (c) {
        var cl = Math.max(c.l, c.w), cw = Math.min(c.l, c.w);
        var covered = cands.some(function (d) {
          var dl = Math.max(d.l, d.w), dw = Math.min(d.l, d.w);
          return dl >= cl && dw >= cw && (dl > cl || dw > cw);
        });
        var t = cl + ' × ' + cw;
        if (!covered && seenS.indexOf(t) < 0) seenS.push(t);
      });
      sizesSay = seenS.length > 1 ? seenS.slice(0, -1).join(', ') + ' or ' + seenS[seenS.length - 1] + 'mm' : sizesSay;
    }
    var tooBig = pieces.filter(function (p) {
      return !cands.some(function (c) { return p.l <= Math.max(c.l, c.w) && p.w <= Math.min(c.l, c.w); });
    });
    if (tooBig.length) {
      var w2 = sp.length === 1 ? 'That piece is' : ('Piece ' + (tooBig[0].idx + 1) + ' is');
      return { ok: false, slab: null, msg: dominant
        ? w2 + ' bigger than the largest slab we hold in this stone (' + sizesSay + '). Split it into two pieces, or call 01908 46 46 56.'
        : w2 + ' too big for any slab we hold in this stone (' + sizesSay + '). Split it into two pieces, or call 01908 46 46 56.' };
    }
    return { ok: false, slab: null, msg: (sp.length === 1 ? 'That piece' : 'Those ' + sp.length + ' pieces') + ' will not come out of one slab once the saw cuts are allowed for — each cut loses about ' + CUT_KERF + 'mm.' + (dominant ? ' The largest we hold in this stone is ' : ' Our slabs in this stone are ') + sizesSay + '. Reduce a dimension, or order the pieces separately.' };
  }

  /* Parts mode: each piece is its own part, cut from the cheapest in-stock
     slab of that part's sizes that it fits. */
  function partsPlan(sp, cands) {
    var keys = activeParts(), out = [], j = 0;
    for (var q = 0; q < keys.length; q++) {
      var key = keys[q], P = PARTS.parts[key] || {};
      if (P.fixed) {
        if (!inStock(P.fixed)) return { ok: false, slab: null, msg: (P.label || '') + ': ' + (PARTS.noStockPart || C.noStock) };
        out.push({ key: key, label: P.label, slab: P.fixed, fixed: true, dims: P.dims, layout: null, piece: null });
        continue;
      }
      var i = j++;
      var pc = partCands(key, cands);
      if (!pc.length) return { ok: false, slab: null, msg: (P.label || '') + ': ' + (PARTS.noStockPart || C.noStock) };
      var piece = { idx: i, l: Math.max(sp[i].l, sp[i].w), w: Math.min(sp[i].l, sp[i].w) }, hit = null;
      for (var k = 0; k < pc.length && !hit; k++) {
        var v = pc[k], L = Math.max(v.l, v.w), W = Math.min(v.l, v.w);
        if (piece.l > L || piece.w > W) continue;
        var lay = packPieces([piece], L, W);
        if (lay) hit = { key: key, label: P.label, slab: v, piece: sp[i], layout: { placements: lay, L: L, W: W, caption: P.label } };
      }
      if (!hit) return { ok: false, slab: null, msg: (P.label || 'That piece') + ' is too big. ' + (P.limit ? P.limit.charAt(0).toUpperCase() + P.limit.slice(1) + '.' : '') + (PARTS.tooBigTail ? ' ' + PARTS.tooBigTail : '') };
      out.push(hit);
    }
    var firstCut = out.filter(function (o) { return !o.fixed; })[0] || out[0];
    return { ok: true, slab: firstCut.slab, slabs: out, layout: firstCut.layout, msg: '' };
  }
  function partsFrom(cands) {
    /* Cheapest possible order for the current choice: the cheapest slab of
       each part, added up. Null if any part has no slab in stock. */
    var keys = activeParts(), total = 0, first = null;
    for (var i = 0; i < keys.length; i++) {
      var fx = PARTS.parts[keys[i]] && PARTS.parts[keys[i]].fixed;
      if (fx) { if (!inStock(fx)) return null; total += fx.price; if (!first) first = fx; continue; }
      var pc = partCands(keys[i], cands);
      if (!pc.length) return null;
      total += pc[0].price; if (!first) first = pc[0];
    }
    return { price: total, slab: first };
  }

  /* ===========================================================================
     PRICES, DATES, FREIGHT
     =========================================================================== */
  function svc() { if (SEC) return SEC.svc; return state.speed === 'priority' ? D.svcExp : D.svcStd; }
  function isOversized(v) {
    if (!v) return false;
    var L = Math.max(v.l, v.w), W = Math.min(v.l, v.w);
    return (L === 1500 && W === 900) || (L === 1200 && W === 1200);
  }
  /* Four live rates: BSD Standard Slab and BSD Oversized Slab profiles,
     economy and express. The page cannot read delivery profiles — change a
     rate in Shipping settings and change it in the theme editor too. */
  function freight(v, mode) {
    mode = mode || state.del;
    if (mode === 'collect') return 0;
    var over = isOversized(v);
    if (mode === 'express') return over ? D.rateOversizedExpress : D.rateStandardExpress;
    return over ? D.rateOversized : D.rateStandard;
  }

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DAYS_S = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MON_S = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  /* Dates (29 Sep 2026): "ready" counts CALENDAR days from tomorrow. Days inside
     a shutdown (D.shutdownDates: dates or "start to end" ranges) do not count,
     so the clock pauses. A ready date that lands on a weekend, bank holiday or
     shutdown day moves to the next working day. Transit (pallet / express) is
     working days counted from the ready date. */
  function isoOf(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  var SHUT = (function () {
    var days = {}, list = D.shutdownDates || [];
    list.forEach(function (raw) {
      String(raw || '').split(/[\n,;]+/).forEach(function (item) {
        item = item.trim(); if (!item) return;
        var m = item.match(/^(\d{4}-\d{2}-\d{2})(?:\s*(?:to|–|—|-{1,2}|\.\.)\s*(\d{4}-\d{2}-\d{2}))?$/i);
        if (!m) return;
        var a = new Date(m[1] + 'T12:00:00'), b = new Date((m[2] || m[1]) + 'T12:00:00'), g = 0;
        while (a <= b && g++ < 120) { days[isoOf(a)] = true; a.setDate(a.getDate() + 1); }
      });
    });
    return days;
  })();
  function isBank(d) { return (D.bankHolidays || []).map(function (x) { return String(x).trim(); }).indexOf(isoOf(d)) >= 0; }
  function isWorking(d) { var w = d.getDay(); return w !== 0 && w !== 6 && !isBank(d) && !SHUT[isoOf(d)]; }
  function nextWorking(d) { var g = 0; while (!isWorking(d) && g++ < 60) d.setDate(d.getDate() + 1); return d; }
  function readyDate(n) {
    var d = new Date(); d.setHours(0, 0, 0, 0);
    var added = 0, guard = 0;
    while (added < n && guard++ < 800) {
      d.setDate(d.getDate() + 1);
      if (SHUT[isoOf(d)]) continue;
      added++;
    }
    return nextWorking(d);
  }
  function addWorkingDaysFrom(start, n) {
    var d = new Date(start.getTime());
    var added = 0, guard = 0;
    while (added < n && guard++ < 400) {
      d.setDate(d.getDate() + 1);
      if (isWorking(d)) added++;
    }
    return d;
  }
  function longDate(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; }
  function shortDate(d) { return DAYS_S[d.getDay()] + ' ' + d.getDate() + ' ' + MON_S[d.getMonth()]; }
  function span(rd, a, b) { return a === b ? shortDate(addWorkingDaysFrom(rd, a)) : shortDate(addWorkingDaysFrom(rd, a)) + ' – ' + shortDate(addWorkingDaysFrom(rd, b)); }

  /* Same shape as the riven page's Signature dates (hearth-parent.js): ready
     on `ready`, then the lorry. */
  function arriveHtml() {
    var ready = state.speed === 'priority' ? D.priorityDays : D.standardDays;
    var rd = readyDate(ready);
    var readyStr = longDate(rd);
    var tail = (C.readyCaveat ? '<br><span class="cts-cav">' + esc(C.readyCaveat) + '</span>' : '')
      + (C.carrierNote ? '<br><span class="cts-cav">' + esc(C.carrierNote) + '</span>' : '');
    if (state.del === 'collect') {
      return '<b>Ready to collect by ' + readyStr + '.</b>'
        + '<br>We email you the moment it is ready. Choose delivery and it is delivered by the same date.' + tail;
    }
    var x = state.del === 'express';
    return '<b>Delivered by ' + readyStr + ' at the latest.</b>'
      + '<br>Or collect free from Milton Keynes: we email you the moment it is ready.' + tail;
  }

  /* ===========================================================================
     LOOK — riven page markup
     =========================================================================== */
  var finSel = $('cts-fin'), thkSel = $('cts-thk'), grdSel = $('cts-grd'),
      pcsSel = $('cts-pcs'), spdSel = $('cts-spd'), delSel = $('cts-del');

  function setOptions(sel, list, current) {
    /* list: [{value, label, disabled}] — rebuilt only if something changed,
       so an open dropdown on a phone is never yanked. */
    var html = list.map(function (o) {
      return '<option value="' + esc(o.value) + '"' + (o.disabled ? ' disabled' : '') + '>' + esc(o.label) + '</option>';
    }).join('');
    if (sel._last !== html) { sel.innerHTML = html; sel._last = html; }
    sel.value = current;
  }

  var lastFin = null;
  function renderStone() {
    if (SEC) return renderSec();
    finSel.value = state.fin;
    $('cts-say-fin').textContent = (FIN[state.fin] && FIN[state.fin].note) || { riven: C.finishRiven, honed: C.finishHoned, brushed: C.finishBrushed }[state.fin] || '';

    var thks = thicknessesFor(state.fin);
    if (thks.indexOf(state.thk) < 0 || !thkAvailable(state.thk)) {
      state.thk = thks.filter(thkAvailable)[0] || thks[0];
    }
    setOptions(thkSel, thks.map(function (t) {
      var ok = thkAvailable(t), d = thkDelta(t);
      return { value: t, disabled: !ok,
        label: t + (d !== null && d > 0 ? '   +' + money(d) : '') + (ok ? '' : '  — ' + C.notInStock) };
    }), state.thk);
    $('cts-say-thk').textContent = thks.length > 1 ? C.thicknessNote : C.thicknessNoteOne;

    var riven = isRiven();
    $('cts-step-grade').style.display = riven ? '' : 'none';
    if (riven) {
      if (!gradeAvailable(state.grade)) state.grade = gradeAvailable('Standard') ? 'Standard' : 'Premium';
      var gd = gradeDelta();
      setOptions(grdSel, [
        { value: 'Standard', label: C.gradeStandardLabel + (gradeAvailable('Standard') ? '' : '  — ' + C.notInStock), disabled: !gradeAvailable('Standard') },
        { value: 'Premium', label: C.gradePremiumLabel + (gd ? '   +' + money(gd) : '') + (gradeAvailable('Premium') ? '' : '  — ' + C.notInStock), disabled: !gradeAvailable('Premium') }
      ], state.grade);
      $('cts-say-grd').textContent = state.grade === 'Premium' ? C.gradePremium : C.gradeStandard;
    }
    /* Step numbers close up when the grade step is hidden. */
    var n = 0;
    document.querySelectorAll('.cts .hp__step').forEach(function (st) {
      if (st.style.display === 'none') return;
      n++;
      var num = st.querySelector('[data-n]'); if (num) num.textContent = n;
    });

    var f = FIN[state.fin];
    $('cts-back').setAttribute('href', f.url);
    if (lastFin !== state.fin) renderGallery(f);
    lastFin = state.fin;
  }

  /* The gallery is the chosen finish's own photos, exactly as its hearth
     page shows them. */
  function renderGallery(f) {
    var media = (f.media && f.media.length) ? f.media : [{ src: f.image, thumb: f.thumb }];
    var img = $('hp-img');
    if (img && media[0].src) { img.src = media[0].src; img.alt = f.title; }
    var wrap = $('cts-thumbs');
    if (!wrap) return;
    if (media.length < 2) { wrap.innerHTML = ''; return; }
    wrap.innerHTML = media.map(function (m, i) {
      return '<button type="button" class="hp__thumb' + (i === 0 ? ' hp__thumb--on' : '') + '" data-src="' + esc(m.src) + '" aria-label="View image ' + (i + 1) + '">'
        + '<img src="' + esc(m.thumb) + '" alt="" width="160" height="160" loading="lazy"></button>';
    }).join('');
  }

  /* Seconds mode: build the seconds-slab step once (a dropdown, like every
     other step; it replaces finish, thickness and grade), fix the turnaround
     at Standard, add the Cut to Size link under the button. Then refresh the
     dropdown and its explainer line on every render. */
  var secBuilt = false, lastSecFin = null;
  function buildSec() {
    secBuilt = true;
    [finSel, thkSel].forEach(function (el) { var st = el.closest('.hp__step'); if (st) st.style.display = 'none'; });
    $('cts-step-grade').style.display = 'none';
    var step = document.createElement('div');
    step.className = 'hp__step';
    step.id = 'cts-step-sec';
    step.innerHTML = '<label class="hp__steplabel" for="cts-sec-sel"><span class="hp__num" data-n>1</span> ' + esc(SC.stepLabel) + '</label>'
      + '<select class="hp__select" id="cts-sec-sel"></select>'
      + '<p class="hp__say" id="cts-sec-say"></p>';
    var cut = $('cts-step-cut');
    cut.parentNode.insertBefore(step, cut);
    $('cts-sec-sel').addEventListener('change', function () {
      state.sec = this.value;
      render(); syncUrl();
    });
    spdSel.value = 'standard';
    spdSel.style.display = 'none';
    var fx = document.createElement('div');
    fx.className = 'cts-fixed';
    fx.textContent = SC.turnaroundFixed;
    spdSel.parentNode.insertBefore(fx, spdSel.nextSibling);
    var note = spdSel.parentNode.querySelector('.hp__say');
    if (note) note.textContent = SC.turnaroundNote;
    var alt = document.createElement('div');
    alt.innerHTML = '<p class="hp__link cts-sec-alt"><a id="cts-sec-alt" href="#"></a></p>'
      + '<p class="hp__link cts-sec-alt" id="cts-sec-stockp" style="display:none"><a id="cts-sec-stock" href="#"></a></p>';
    var form = $('hp-form');
    form.parentNode.insertBefore(alt, form.nextSibling);
  }
  function renderSec() {
    if (!secBuilt) buildSec();
    var v = secSync(), list = secList();
    var sel = $('cts-sec-sel');
    setOptions(sel, list.map(function (x) {
      return { value: String(x.id), label: x.label + ' · ' + sizeLabel(x) + ' · ' + x.thk + ' — ' + money(x.price) + ' · ' + x.qty + ' ' + SC.leftWord };
    }), v ? String(v.id) : '');
    sel.style.display = list.length ? '' : 'none';
    var np = v ? normalPrice(v) : 0;
    $('cts-sec-say').textContent = v
      ? (np > v.price ? SC.normalWord + ' ' + money(np) + '. ' : '') + String(SC.roomNote || '').replace('{use}', secUse()).replace('{max}', secMaxOne(v))
      : SC.soldOut;
    var total = list.reduce(function (a, x) { return a + x.qty; }, 0);
    var stockEl = $('hp-stock');
    if (stockEl) stockEl.textContent = '✓ ' + total + ' ' + SC.stockWord;
    var n = 0;
    document.querySelectorAll('.cts .hp__step').forEach(function (st) {
      if (st.style.display === 'none') return;
      n++;
      var num = st.querySelector('[data-n]'); if (num) num.textContent = n;
    });
    var f = FIN[state.fin];
    if (f) {
      $('cts-back').setAttribute('href', f.url);
      if (lastSecFin !== state.fin) renderGallery(f);
      lastSecFin = state.fin;
    }
  }
  /* Save panel: the same pieces on the cheapest in-stock seconds slab of this
     finish, thickness and grade that they fit (leaving the minimum offcut),
     against this page's own Standard total with the same delivery. Standard
     turnaround only, so nothing is offered while Priority is chosen. Returns
     null when there is no saving to show. Puts everything back as it found it. */
  function offerQuote(plan) {
    if (!OFFER || !plan || !plan.ok || plan.slabs || state.speed === 'priority') return null;
    var list = OFFER.slabs.filter(function (v) {
      return inStock(v) && v.l > 0 && v.w > 0 && v.fin === state.fin && String(v.thk) === String(state.thk)
        && (state.fin !== 'riven' || (v.grade || 'Standard') === state.grade);
    }).sort(function (a, b) { return a.price - b.price; });
    var keepSec = SEC, keepSel = state.sec, best = null;
    SEC = OFFER;
    try {
      for (var i = 0; i < list.length && !best; i++) {
        state.sec = list[i].id;
        var p = cutPlan();
        if (p.ok && p.slab && String(p.slab.id) === String(list[i].id)) best = list[i];
      }
    } catch (e) { best = null; }
    SEC = keepSec; state.sec = keepSel;
    if (!best) return null;
    var was = plan.slab.price + D.svcStd.price + freight(plan.slab);
    var now = best.price + OFFER.svc.price + freight(best);
    if (now >= was) return null;
    return { save: was - now, was: was, now: now, slab: best, pieces: specs(), del: state.del };
  }
  /* The same pieces on full Cut to Size (Standard), for the comparison link. */
  function normalQuote() {
    var keep = SEC, p = null;
    SEC = null;
    try { p = cutPlan(); } catch (e) { p = null; }
    SEC = keep;
    return p && p.ok ? p.slab.price + D.svcStd.price + freight(p.slab) : null;
  }
  function renderSecAlt(soldOut) {
    var a = $('cts-sec-alt'), sp = $('cts-sec-stockp'), sa = $('cts-sec-stock');
    if (!a) return;
    var url = SEC.ctsUrl + '?finish=' + encodeURIComponent(state.fin) + '&thk=' + encodeURIComponent(state.thk) + (state.grade === 'Premium' ? '&grade=Premium' : '');
    if (soldOut) {
      a.setAttribute('href', SEC.ctsUrl);
      a.textContent = SEC.ctsFrom ? String(SC.altSoldOut || '').replace('{price}', money(SEC.ctsFrom)) : SC.altPlain;
      sa.setAttribute('href', SEC.stockUrl);
      sa.textContent = String(SC.altStock || '').replace('{price}', money(SEC.stockFrom || 0));
      sp.style.display = SEC.stockFrom ? '' : 'none';
      return;
    }
    sp.style.display = 'none';
    var q = normalQuote();
    a.setAttribute('href', url);
    a.textContent = q ? String(SC.altWith || '').replace('{price}', money(q)) : SC.altPlain;
  }

  function readPieces() {
    var n = PARTS ? cutKeys().length : (parseInt(pcsSel.value, 10) || 1);
    var list = [];
    for (var i = 1; i <= n; i++) {
      var le = $('cts-l-' + i), we = $('cts-w-' + i);
      list.push({ l: le ? le.value : '', w: we ? we.value : '' });
    }
    state.pieces = list;
  }
  function renderRows() {
    if (PARTS) return renderPartRows();
    var wrap = $('cts-rows'), n = parseInt(pcsSel.value, 10) || 1;
    if (wrap.querySelectorAll('.hp__piecerow').length === n) return;
    var kept = {};
    for (var k = 1; k <= 3; k++) {
      var le = $('cts-l-' + k), we = $('cts-w-' + k);
      if (le || we) kept[k] = { l: le ? le.value : '', w: we ? we.value : '' };
    }
    var html = '';
    for (var i = 1; i <= n; i++) {
      var prev = kept[i] || { l: '', w: '' };
      html += '<div class="hp__piecerow">'
        + (n > 1 ? '<span class="hp__piecelabel">Piece ' + i + '</span>' : '')
        + '<input type="number" id="cts-l-' + i + '" min="1" max="9999" inputmode="numeric" autocomplete="off" aria-label="Piece ' + i + ' length in mm" placeholder="' + esc(C.lengthPlaceholder) + '" value="' + esc(prev.l) + '">'
        + '<span>×</span>'
        + '<input type="number" id="cts-w-' + i + '" min="1" max="9999" inputmode="numeric" autocomplete="off" aria-label="Piece ' + i + ' width in mm" placeholder="' + esc(C.widthPlaceholder) + '" value="' + esc(prev.w) + '">'
        + '<span>mm</span></div>';
    }
    wrap.innerHTML = html;
  }

  var partVals = {};
  function renderPartRows() {
    var wrap = $('cts-rows'), keys = activeParts(), sig = keys.join(',');
    if (wrap._sig === sig) return;
    for (var k = 1; k <= 3; k++) {
      var le = $('cts-l-' + k), we = $('cts-w-' + k);
      if (le && le.getAttribute('data-part')) partVals[le.getAttribute('data-part')] = { l: le.value, w: we ? we.value : '' };
    }
    var html = '', ci = 0;
    keys.forEach(function (key) {
      var P = PARTS.parts[key] || {};
      if (P.fixed) {
        html += '<p class="hp__say cts-partlimit"><b>' + esc(P.label) + '</b> · ' + esc(P.dims) + '</p>'
          + (P.note ? '<p class="hp__say cts-partfixed">' + esc(P.note) + '</p>' : '');
        return;
      }
      var i = ++ci, prev = partVals[key] || { l: '', w: '' };
      html += (P.limit ? '<p class="hp__say cts-partlimit"><b>' + esc(P.label) + '</b> · ' + esc(P.limit) + '</p>' : '')
        + '<div class="hp__piecerow">'
        + '<input type="number" id="cts-l-' + i + '" data-part="' + esc(key) + '" min="1" max="9999" inputmode="numeric" autocomplete="off" aria-label="' + esc(P.label) + ' length in mm" placeholder="' + esc(C.lengthPlaceholder) + '" value="' + esc(prev.l) + '">'
        + '<span>×</span>'
        + '<input type="number" id="cts-w-' + i + '" min="1" max="9999" inputmode="numeric" autocomplete="off" aria-label="' + esc(P.label) + ' width in mm" placeholder="' + esc(C.widthPlaceholder) + '" value="' + esc(prev.w) + '">'
        + '<span>mm</span></div>';
    });
    wrap.innerHTML = html;
    wrap._sig = sig;
  }

  /* 28 Sep: clearer drawing. Slab outline with its length and width marked,
     each piece labelled with its number and size (as entered), "turned" when
     the packer rotated it, and the offcut hatched and labelled. Drawing only:
     the layout itself comes from packPieces(), unchanged. */
  var DIAG_W = 420, DIAG_PAD = 22, diagSeq = 0;
  var NUMS = ['①', '②', '③'];
  function freeRect(layout) {
    /* Largest empty rectangle on the slab (for the "Offcut" label). */
    var L = layout.L, W = layout.W, P = layout.placements;
    var xs = [0, L], ys = [0, W];
    P.forEach(function (p) { xs.push(p.x, Math.min(L, p.x + p.l)); ys.push(p.y, Math.min(W, p.y + p.w)); });
    xs = xs.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    ys = ys.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    function hit(x0, y0, x1, y1) {
      return P.some(function (p) { return x0 < p.x + p.l && x1 > p.x && y0 < p.y + p.w && y1 > p.y; });
    }
    var best = null;
    for (var a = 0; a < xs.length; a++) for (var b = a + 1; b < xs.length; b++)
      for (var c = 0; c < ys.length; c++) for (var d = c + 1; d < ys.length; d++) {
        var ar = (xs[b] - xs[a]) * (ys[d] - ys[c]);
        if (best && ar <= best.a) continue;
        if (!hit(xs[a], ys[c], xs[b], ys[d])) best = { a: ar, x: xs[a], y: ys[c], l: xs[b] - xs[a], w: ys[d] - ys[c] };
      }
    return best;
  }
  function diagramSvg(layout, maxL, sp, numbered, base) {
    /* base = drawing width in screen pixels (narrower on phones), so the
       labels stay at their real size instead of shrinking with the drawing. */
    var L = layout.L, W = layout.W, pad = DIAG_PAD;
    var DW = maxL ? Math.round(base * L / maxL) : base, sc = DW / L, DH = Math.round(W * sc);
    var VW = DW + pad + 2, VH = DH + pad + 2, id = 'cts-h' + (++diagSeq);
    var widthPct = maxL ? (100 * VW / (base + pad + 2)).toFixed(1) + '%' : '100%';
    var s = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" width="' + VW + '" height="' + VH + '" style="width:' + widthPct + ';height:auto;border:0;background:none" role="img" aria-label="Cutting layout on a ' + L + ' by ' + W + ' slab">';
    s += '<defs><pattern id="' + id + '" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="8" height="8" fill="#f4f3f0"></rect><line x1="0" y1="0" x2="0" y2="8" stroke="#cfcbc2" stroke-width="2"></line></pattern></defs>';
    s += '<g transform="translate(' + pad + ',' + pad + ')">';
    s += '<text x="' + (DW / 2) + '" y="-8" fill="#5b5953" font-size="12" text-anchor="middle">' + L + ' mm</text>';
    s += '<text x="-8" y="' + (DH / 2) + '" fill="#5b5953" font-size="12" text-anchor="middle" transform="rotate(-90 -8 ' + (DH / 2) + ')">' + W + ' mm</text>';
    s += '<rect x="0" y="0" width="' + DW + '" height="' + DH + '" fill="url(#' + id + ')"></rect>';
    layout.placements.forEach(function (p) {
      var x = p.x * sc, y = p.y * sc, w = p.l * sc, h = p.w * sc, cx = x + w / 2, cy = y + h / 2;
      s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="#212121" stroke="#fff" stroke-width="1.5"></rect>';
      var e = sp && sp[p.idx], size = e ? e.l + ' × ' + e.w : (p.rot ? p.w + ' × ' + p.l : p.l + ' × ' + p.w);
      var num = NUMS[p.idx] || String(p.idx + 1);
      /* Try: "① 1080 × 500", then number and size on two lines, then the
         number alone. "turned" goes underneath when there is room. */
      var opts = numbered ? [[num + ' ' + size], [num, size], [num]] : [[size]], ls = null;
      function fits(o) {
        return o.every(function (t) { return t.length * 7.6 + 8 <= w; }) && o.length * 16 + 4 <= h;
      }
      for (var q = 0; q < opts.length && !ls; q++) {
        if (p.rot && fits(opts[q].concat(['turned']))) ls = opts[q].concat(['turned']);
        else if (fits(opts[q])) ls = opts[q];
      }
      if (!ls) return;
      var y0 = cy - (ls.length - 1) * 8 + 5;
      ls.forEach(function (t, k) {
        var tn = t === 'turned' && k === ls.length - 1 && p.rot;
        s += '<text x="' + cx + '" y="' + (y0 + k * 16) + '"' + (tn ? ' fill="#d8d5ce" font-size="11.5"' : ' fill="#fff" font-size="13" font-weight="600"') + ' text-anchor="middle">' + esc(t) + '</text>';
      });
    });
    var fr = freeRect(layout);
    if (fr && fr.l * sc >= 64 && fr.w * sc >= 20) {
      var ox = (fr.x + fr.l / 2) * sc, oy = (fr.y + fr.w / 2) * sc;
      s += '<rect x="' + (ox - 30) + '" y="' + (oy - 11) + '" width="60" height="18" fill="#f4f3f0"></rect>'
        + '<text x="' + ox + '" y="' + (oy + 3) + '" fill="#5b5953" font-size="12" text-anchor="middle">Offcut</text>';
    }
    s += '<rect x="0" y="0" width="' + DW + '" height="' + DH + '" fill="none" stroke="#1c1c1c" stroke-width="2"></rect>';
    return s + '</g></svg>';
  }
  function renderDiagram(layout) {
    var el = $('cts-diagram');
    if (!layout) { el.innerHTML = ''; return; }
    var sp = specs(), note = '<p class="hp__diagramnote">' + esc(C.diagramNote) + '</p>';
    /* The box is hidden while empty, so measure its parent panel instead. */
    var box = el.clientWidth, par = el.parentNode;
    if (!box && par && par.clientWidth) { var cs = getComputedStyle(par); box = par.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight); }
    var base = Math.max(240, Math.min(DIAG_W, (box || DIAG_W + DIAG_PAD + 2) - DIAG_PAD - 2));
    if (layout.length) {
      /* Parts mode: one drawing per slab, each captioned with its part, all
         at ONE scale (the longest slab sets it). One piece per slab, so no
         piece numbers. */
      var ml = layout.reduce(function (a, l) { return Math.max(a, l.L); }, 0);
      el.innerHTML = layout.map(function (lay) {
        return (lay.caption ? '<p class="hp__diagramnote"><b>' + esc(lay.caption) + '</b> · ' + lay.L + ' × ' + lay.W + ' slab</p>' : '') + diagramSvg(lay, ml, sp, false, base);
      }).join('') + note;
      return;
    }
    el.innerHTML = '<p class="hp__diagramnote"><b>' + layout.L + ' × ' + layout.W + ' slab</b></p>'
      + diagramSvg(layout, 0, sp, layout.placements.length > 1, base) + note;
  }

  function sizeLabel(v) { return v.l + ' × ' + v.w; }

  function render() {
    renderStone();
    if (PARTS) syncChoices();
    renderRows();
    readPieces();

    var plan = cutPlan();
    var sv = svc();
    var cands = candidates();
    var from = cands.length ? cands[0] : null;
    if (PARTS) { var pf = partsFrom(cands); from = pf ? { price: pf.price, l: pf.slab.l, w: pf.slab.w } : null; }
    var sp = specs(), n = sp.length;

    /* ---- step 4 verdict and diagram ---- */
    var valid = $('cts-valid');
    if (plan.ok) {
      var used = sp.reduce(function (a, p) { return a + p.l * p.w; }, 0);
      var off = Math.max(0, Math.round(100 - used / (plan.layout.L * plan.layout.W) * 100));
      valid.className = 'hp__valid hp__valid--ok';
      if (plan.slabs) {
        valid.textContent = '✓ ' + plan.slabs.map(function (s) {
          if (s.fixed) return s.label + ': stock ' + s.slab.l + ' × ' + s.slab.w + ' slab, not cut';
          var o = Math.max(0, Math.round(100 - s.piece.l * s.piece.w / (s.layout.L * s.layout.W) * 100));
          return s.label + ' from one ' + s.layout.L + ' × ' + s.layout.W + ' slab (' + o + '% offcut)';
        }).join(' · ') + '.';
        renderDiagram(plan.slabs.filter(function (s) { return s.layout; }).map(function (s) { return s.layout; }));
      } else {
      var turned = plan.layout.placements.filter(function (p) { return p.rot; }).map(function (p) { return p.idx; }).sort();
      valid.textContent = '✓ ' + (n === 2 ? 'Both pieces come' : n > 1 ? 'All ' + n + ' pieces come' : 'Your piece comes') + ' out of one '
        + plan.layout.L + ' × ' + plan.layout.W + ' slab, with ' + off + '% offcut.'
        + (!turned.length ? '' : n === 1 ? ' It is turned to fit.'
          : turned.length === 1 ? ' Piece ' + NUMS[turned[0]] + ' is turned to fit.'
          : ' Pieces ' + turned.map(function (t) { return NUMS[t]; }).join(' and ') + ' are turned to fit.');
      renderDiagram(plan.layout);
      }
    } else {
      var filled = sp.every(function (x) { return x.l && x.w; });
      valid.className = 'hp__valid' + (plan.msg ? ' hp__valid--bad' : '');
      valid.textContent = plan.msg || (filled ? '' : C.piecesPrompt);
      renderDiagram(null);
    }

    /* ---- step 6 explainer: band follows the slab that was picked ---- */
    var bandSlab = plan.ok ? plan.slab : from;
    var over = plan.ok && isOversized(plan.slab);
    $('cts-say-del').textContent = state.del === 'collect' ? C.collectDesc
      : ((state.del === 'express' ? C.expressDesc : C.deliverDesc) + (over ? ' ' + C.oversizeNote : ''));
    syncPostcode(bandSlab);

    /* ---- price under the title, breakdown, total ---- */
    var priceEl = $('hp-price'), linesEl = $('hp-lines');
    var priceText;
    if (plan.ok) {
      var fr = freight(plan.slab);
      var f = FIN[state.fin];
      var slabList = plan.slabs || [{ slab: plan.slab, label: 'Slab' }];
      var slabsTotal = slabList.reduce(function (a, s) { return a + s.slab.price; }, 0);
      var total = slabsTotal + sv.price + fr;
      priceText = money(total);
      var delLine = state.del === 'express' ? C.expressLineLabel : (state.del === 'deliver' ? C.deliverLineLabel : C.collectLineLabel);
      var rows = slabList.map(function (s) {
        return [(plan.slabs ? s.label + ' · slab ' : (SEC ? SC.slabLine + ' · ' : 'Slab · ')) + sizeLabel(s.slab) + ' × ' + s.slab.thk + ' ' + f.label.toLowerCase() + (s.slab.grade ? ' · ' + s.slab.grade : ''), money(s.slab.price)];
      }).concat([
        [(SEC ? SC.serviceLine : C.serviceLine) + ' · ' + (state.speed === 'priority' ? C.priorityWord : C.standardWord), money(sv.price)],
        [delLine, fr ? money(fr) : C.freeLabel]
      ]);
      linesEl.innerHTML = rows.map(function (r) {
        return '<div class="hp__line"><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>';
      }).join('') + '<div class="hp__line hp__line--total"><span>' + esc(C.totalLabel) + '</span><span>' + money(total) + '</span></div>';
    } else {
      /* An honest "from": the cheapest in-stock slab in this stone, the
         cutting charge, and the delivery choice as it stands. */
      priceText = from ? C.fromWord + ' ' + money(from.price + sv.price + freight(from)) : C.pricePending;
      linesEl.innerHTML = '';
    }
    if (SEC && !cands.length) priceText = SC.soldOutPrice;
    priceEl.textContent = priceText;
    if (SEC) renderSecAlt(!cands.length);

    var stockEl = $('hp-stock');
    if (stockEl) stockEl.style.display = cands.length ? '' : 'none';

    var arr = $('hp-arrive');
    if (plan.ok) { arr.innerHTML = arriveHtml(); arr.style.display = 'block'; }
    else { arr.style.display = 'none'; }

    /* ---- buttons ---- */
    var atc = $('hp-atc');
    atc.disabled = !!(SEC && !cands.length); /* BSD-073: never greyed out; before sizes the button goes to the sizes */
    var needs = (SEC && !cands.length) ? SC.soldOutBtn : C.atcNeedsCut;
    atc.textContent = plan.ok ? C.atcLabel : needs;
    var sb = $('hp-sticky-btn');
    if (sb) sb.textContent = plan.ok ? C.atcLabel : needs;
    var spEl = $('hp-sticky-price'); if (spEl) spEl.textContent = priceText;
    var sm = $('hp-sticky-meta');
    if (sm) sm.textContent = plan.ok
      ? sp.map(function (x) { return x.l + '×' + x.w; }).join(' · ') + 'mm · ' + FIN[state.fin].label + ' ' + state.thk
      : FIN[state.fin].label + ' ' + state.thk;

    if (OFFER) {
      var oq = null;
      try { oq = offerQuote(plan); } catch (e) { oq = null; }
      window.ctsOffer = oq;
      try { document.dispatchEvent(new CustomEvent('cts:offer', { detail: oq })); } catch (e) { /* older browsers: no panel */ }
    }

    render.plan = plan; /* BSD-073: figures for the add-on look (assets/bsd-cts-073.js) */ try { var b73s = plan.ok ? (plan.slabs || [{ slab: plan.slab }]).reduce(function (a, x) { return a + x.slab.price; }, 0) : null, b73r = plan.ok ? plan.slab : from, b73a = readyDate(D.standardDays), b73b = readyDate(D.priorityDays); document.dispatchEvent(new CustomEvent('cts:render', { detail: { ok: !!plan.ok, slabs: b73s, svc: sv.price, total: plan.ok ? b73s + sv.price : null, speed: state.speed, fin: state.fin, std: D.svcStd.price, pri: D.svcExp.price, stdDate: longDate(b73a), priDate: longDate(b73b), stdShort: shortDate(b73a), priShort: shortDate(b73b), pallet: b73r ? freight(b73r, 'deliver') : D.rateStandard, stdDays: D.standardDays, priDays: D.priorityDays, soldOut: !cands.length } })); } catch (e) {}
  }

  /* ===========================================================================
     POSTCODE — the riven page's checker, shown for Pallet AND Express
     (the live riven page shows it for Pallet only; logged to fix there).
     Same area lists and sessionStorage key as the cart.
     =========================================================================== */
  var SCOTLAND = ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'TD', 'ZE'];
  var NI = ['BT'], CROWN = ['IM', 'JE', 'GY'];
  var pcWrap = $('cts-pc'), pcIn = $('cts-pc-input'), pcBtn = $('cts-pc-btn'), pcOut = $('cts-pc-result');
  var pcSlab = null;
  function classify(raw) {
    var s = String(raw || '').replace(/\s/g, '').toUpperCase();
    if (s.length < 5) return 'invalid';
    var m = s.match(/^([A-Z]{1,2})/);
    if (!m) return 'invalid';
    if (NI.indexOf(m[1]) !== -1 || CROWN.indexOf(m[1]) !== -1 || SCOTLAND.indexOf(m[1]) !== -1) return 'quote';
    return 'ew';
  }
  function pcCheck(raw) {
    var kind = classify(raw), tidy = String(raw || '').replace(/\s/g, '').toUpperCase();
    if (kind === 'invalid') { pcOut.innerHTML = '<div class="hp__pcres hp__pcres--bad">' + esc(PCC.invalid) + '</div>'; return; }
    if (kind === 'quote') {
      pcOut.innerHTML = '<div class="hp__pcres hp__pcres--quote">'
        + '<p><strong>' + esc(tidy) + '</strong> — ' + esc(PCC.quoteLead) + '</p>'
        + '<p>' + esc(PCC.quoteRangeLead) + ' <strong>' + esc(isOversized(pcSlab) ? PCC.rangeOversized : PCC.rangeStandard) + '</strong> ' + esc(PCC.vatSuffix) + '. ' + esc(PCC.quoteRangeNote) + '</p>'
        + '<p class="hp__pccontact"><a href="tel:' + esc(PCC.phoneHref) + '">' + esc(PCC.phoneLabel) + '</a> &nbsp;·&nbsp; '
        + '<a href="' + esc(PCC.whatsappHref) + '" rel="noopener">' + esc(PCC.whatsappLabel) + '</a></p></div>';
      return;
    }
    pcOut.innerHTML = '<div class="hp__pcres hp__pcres--ok"><p class="hp__pcres__t">' + esc(PCC.okTitle) + '</p>'
      + '<p>' + esc(PCC.okRateLead) + ' <strong>' + money(freight(pcSlab)) + '</strong> ' + esc(PCC.vatSuffix) + '</p></div>';
  }
  function syncPostcode(slab) {
    pcSlab = slab;
    var on = state.del !== 'collect';
    pcWrap.className = 'hp__pc' + (on ? ' is-on' : '');
    if (!on) return;
    if (!pcOut.innerHTML) {
      var saved = '';
      try { saved = sessionStorage.getItem('bsd_postcode') || ''; } catch (e) {}
      if (saved) { pcIn.value = saved; }
    }
    if (pcIn.value.trim() && (pcOut.innerHTML || pcIn.value)) pcCheck(pcIn.value.trim());
  }
  pcBtn.addEventListener('click', function () {
    var v = pcIn.value.trim();
    try { sessionStorage.setItem('bsd_postcode', v); } catch (e) {}
    pcCheck(v);
  });
  pcIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); pcBtn.click(); } });
  pcIn.addEventListener('input', function () {
    pcOut.innerHTML = '';
    try { sessionStorage.removeItem('bsd_postcode'); } catch (e) {}
  });

  /* ===========================================================================
     EVENTS
     =========================================================================== */
  finSel.addEventListener('change', function () { state.fin = finSel.value; render(); syncUrl(); });
  thkSel.addEventListener('change', function () { state.thk = thkSel.value; render(); });
  grdSel.addEventListener('change', function () { state.grade = grdSel.value; render(); });
  pcsSel.addEventListener('change', function () { if (PARTS) state.part = pcsSel.value; render(); });
  spdSel.addEventListener('change', function () { state.speed = spdSel.value; render(); });
  delSel.addEventListener('change', function () { state.del = delSel.value; render(); });
  $('cts-rows').addEventListener('input', render);

  $('cts-thumbs').addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.hp__thumb') : null;
    if (!t) return;
    $('hp-img').src = t.getAttribute('data-src');
    document.querySelectorAll('#cts-thumbs .hp__thumb').forEach(function (x) { x.classList.toggle('hp__thumb--on', x === t); });
  });

  var ct = $('hp-cont-toggle'), cfds = $('hp-cont-fields'), copen = false;
  ct.addEventListener('click', function () {
    copen = !copen;
    cfds.className = 'hp__contfields' + (copen ? ' is-on' : '');
    ct.textContent = copen ? C.contractorOpen : C.contractorClosed;
  });

  /* Sticky button: adds when the order is complete, otherwise takes the
     shopper back to the cutting size — the one thing still missing. */
  $('hp-sticky-btn').addEventListener('click', function () {
    var plan = render.plan;
    if (plan && plan.ok) { $('hp-atc').click(); return; }
    var step = $('cts-step-cut');
    var y = step.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    var first = $('cts-l-1'); if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  });

  function goToSizes() { var st = $('cts-step-cut'); window.scrollTo({ top: Math.max(0, st.getBoundingClientRect().top + window.pageYOffset - 90), behavior: 'smooth' }); var f1 = document.querySelector('#cts-rows input'); if (f1) { try { f1.focus({ preventScroll: true }); } catch (e) { f1.focus(); } } } function syncUrl() {
    if (!window.history || !history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      if (SEC) { u.searchParams.delete('finish'); if (state.sec) u.searchParams.set('slab', state.sec); }
      else u.searchParams.set('finish', state.fin);
      history.replaceState({}, '', u.toString());
    } catch (e) { /* older browsers keep the bare URL */ }
  }

  /* ===========================================================================
     ADD TO BASKET — the real slab + the real cutting service, paired.
     Property names match hearth-parent.js so the cart, the packing slip and
     the workshop read both pages the same way.
     =========================================================================== */
  $('hp-form').addEventListener('submit', function (e) {
    e.preventDefault();
    render();
    var plan = render.plan;
    if (!plan || !plan.ok) { goToSizes(); return; }
    var sv = svc();
    if (!sv.id) { alert(C.atcError); return; }
    var btns = [$('hp-atc'), $('hp-sticky-btn')];
    btns.forEach(function (b) { if (b) { b.disabled = true; b.textContent = C.atcAdding; } });

    var sp = specs();
    var dims = sp.length === 1 ? (sp[0].l + ' × ' + sp[0].w + 'mm')
      : sp.map(function (s) { return 'Piece ' + s.i + ': ' + s.l + ' × ' + s.w + 'mm'; }).join(' · ');
    function partDims(s) { return s.fixed ? (s.dims || (s.slab.l + ' × ' + s.slab.w + 'mm')) + ' — stock slab, not cut' : s.piece.l + ' × ' + s.piece.w + 'mm'; }
    if (plan.slabs) dims = plan.slabs.map(function (s) { return s.label + ': ' + partDims(s); }).join(' · ');
    var pairToken = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var fr = freight(plan.slab);
    var delProp = (state.del === 'express' ? C.expressLineLabel : (state.del === 'deliver' ? C.deliverLineLabel : C.collectLineLabel))
      + ' — ' + (fr ? money(fr) : C.freeLabel);
    if (state.del === 'collect') delProp += '. ' + C.pickupHint;

    var props = {
      '_pair': pairToken,
      'Service': (SEC ? SC.serviceLine : C.serviceLine) + ' — ' + (state.speed === 'priority' ? C.priorityWord : C.standardWord),
      'Dimensions': dims, 'Delivered by': longDate(readyDate(state.speed === 'priority' ? D.priorityDays : D.standardDays))
    };
    if (sp.length > 1 && !plan.slabs) props['Pieces'] = String(sp.length);
    if (SEC && SC.basketNote) props['Budget Cut to Size'] = SC.basketNote;
    var cn = $('hp-cont-name').value, cp = $('hp-cont-phone').value, ce = $('hp-cont-email').value;
    if (cn) props['Installer name'] = cn;
    if (cp) props['Installer phone'] = cp;
    if (ce) props['Installer email'] = ce;

    var f = FIN[state.fin];
    var items = [
      { id: plan.slab.id, quantity: 1, properties: props },
      { id: sv.id, quantity: 1, properties: { 'For product': SEC ? SEC.title : f.title, 'Slab': plan.slab.title, '_pair': pairToken, '_image': f.thumb } }
    ];
    if (plan.slabs) {
      /* Parts mode: one line per slab (each names its part and size), then
         ONE cutting-service line. All share the _pair token, so removing any
         of them in the cart removes the set (bsd-cart-pairing.js). */
      items = plan.slabs.map(function (s, k) {
        var pp = {};
        Object.keys(props).forEach(function (key) { pp[key] = props[key]; });
        pp['Part'] = s.label;
        pp['Dimensions'] = partDims(s);
        if (k > 0) delete pp['_delivery'];
        return { id: s.slab.id, quantity: 1, properties: pp };
      });
      items.push({ id: sv.id, quantity: 1, properties: { 'For product': f.title, 'Slab': plan.slabs.map(function (s) { return s.label + ': ' + s.slab.title; }).join(' + '), '_pair': pairToken, '_image': f.thumb } });
    }
    function addOne(item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Add to cart failed'); });
        return r.json();
      });
    }
    items.reduce(function (chain, it) { return chain.then(function () { return addOne(it); }); }, Promise.resolve())
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        render();
        alert(C.atcError);
        if (window.console) console.error('Cut to size ATC error:', err);
      });
  });

  /* Start: the selects show the state (finish may come from ?finish=). */
  if (PARTS) syncChoices();
  spdSel.value = state.speed;
  delSel.value = state.del;
  render();
  /* Pieces carried over from the Save panel (?pieces=1200x400,600x300). Seconds page only. */
  if (SEC && PREFILL.length) {
    pcsSel.value = String(PREFILL.length);
    renderRows();
    PREFILL.forEach(function (p, i) {
      var le = $('cts-l-' + (i + 1)), we = $('cts-w-' + (i + 1));
      if (le) le.value = p.l;
      if (we) we.value = p.w;
    });
    render();
  }
})();